import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import SingleMovie from '../SingleMovie';
import LoadingSpinner from '../../LoadingSpinner';
import { reloadMovies, moviePageNumber, filterSelection, moviePageNumber_b, moviePageNumber_h, moviePageNumber_s, moviePageNumber_g } from '../../../redux/action/allActions'
import { useNavigate } from "react-router-dom";
import Constants from "../../Constants";
import { loadDbCinemaRecords } from "../../ApiServices";
import Pagination from "../Pagination";

function Movie(props) {
    const dispatch = useDispatch();
    const [movieList, setMovieList] = useState(require('../../../movieList.json'))
    const [loading, setLoading] = useState(true);
    const userData = props.userData;
    const userRole = props.userRole;
    const reload = useSelector(state => state.reloadMoviesReducer)
    const moviePageNumberList = useSelector(state => state.moviePageNumberReducer)
    const filter = useSelector(state => state.filterSelectionReducer)
    const [navLinkActive, setNavLinkActive] = useState(filter.movieIndustry);
    const [disPageNumber, setDisPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);


    const navigate = useNavigate();

    const onReSize = () => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }

    const displayCol = () => {
        let displayCol = "4";
        if(windowSize[0] > 1100 && windowSize[0] < 1500){
            displayCol = "3";
        }else if(windowSize[0] > 767 && windowSize[0] < 1200){
            displayCol = "2";
        }
        return displayCol;
    }

    const loadMovies = async () => {

        setLoading(true);

        // var api = ""
        // if (filter.movieIndustry === "all") {
        //     api = `/api/media/movie?industry=${filter.movieIndustry}&page=${moviePageNumberList.all}`
        //     setPageNumber(moviePageNumberList.all)
        // }
        // else if (filter.movieIndustry === "bollywood") {
        //     api = `/api/media/movie?industry=${filter.movieIndustry}&page=${moviePageNumberList.bollywood}`
        //     setPageNumber(moviePageNumberList.bollywood)
        // }
        // else if (filter.movieIndustry === "hollywood") {
        //     api = `/api/media/movie?industry=${filter.movieIndustry}&page=${moviePageNumberList.hollywood}`
        //     setPageNumber(moviePageNumberList.hollywood)
        // }
        // else if (filter.movieIndustry === "south") {
        //     api = `/api/media/movie?industry=${filter.movieIndustry}&page=${moviePageNumberList.south}`
        //     setPageNumber(moviePageNumberList.south)
        // }
        // else if (filter.movieIndustry === "gujarati") {
        //     api = `/api/media/movie?industry=${filter.movieIndustry}&page=${moviePageNumberList.gujarati}`
        //     setPageNumber(moviePageNumberList.gujarati)
        // }
        // const res = await fetch(api, {
        //     method: "GET",
        //     headers: {
        //         "Content-Type": "application/json",
        //         Accept: "application/json"
        //     }
        // });

        // const data = await res.json();

        // if (res.status === 200) {
        //     setMovieList(data[0]);
        //     setPageCount(data[1]);
        //     setLoading(false);
        // }
        // else if (res.status === 401) {
        //     // alert("User needs to first login.")
        //     // alert(data.errorMessage + Constants.RE_LOGIN);
        //     navigate(`${Constants.LOGIN_ROUTE}?redirectTo=${Constants.DB_MOVIES_ROUTE}`, { replace: true });
        // }
        // else {
        //     alert(data.errorMessage);
        //     navigate(`${Constants.LOGIN_ROUTE}?redirectTo=${Constants.DB_MOVIES_ROUTE}`, { replace: true });
        // }
        // setLoading(false);


        const response = await loadDbCinemaRecords(filter, moviePageNumberList);
        if (response && response !== null) {
            setMovieList(response.result.records);
            setPageCount(response.result.pageCount);
            setDisPageNumber(response.result.disPageNumber);
            setLoading(false);
        } else {
            alert(response.errorMessage);
            navigate(`${Constants.LOGIN_ROUTE}?redirectTo=${Constants.DB_MOVIES_ROUTE}`, { replace: true });
        }

    }

    useEffect(() => {
        onReSize();
        loadMovies();
    }, [reload, filter, moviePageNumberList])

    return (
        <>
            <div className="mb-3 p-1" style={{ display: "flex", flexWrap: "nowrap", background: "rgba(255 ,255 ,255, 0.9)", borderRadius: "3px" }}>
                <ButtonToolbar aria-label="Toolbar with button groups" className="m-1" style={{ overflowX: "auto", flexWrap: "nowrap" }}>
                    <ButtonGroup className="mx-2" aria-label="First group">
                        <Button
                            variant={filter.movieIndustry === "all" ? "dark" : "outline-secondary"}
                            href="#all"
                            data-toggle="tab"
                            onClick={() => {
                                // dispatch(moviePageNumber(0));
                                // setNavLinkActive("all")
                                dispatch(filterSelection({
                                    ...filter,
                                    catagory: "movie",
                                    movieIndustry: "all"
                                }))
                            }
                            }
                        >All</Button>
                    </ButtonGroup>
                    <ButtonGroup className="mx-2" aria-label="Second group">
                        <Button
                            variant={filter.movieIndustry === "bollywood" ? "dark" : "outline-secondary"}
                            href="#bollywood"
                            data-toggle="tab"
                            onClick={() => {
                                // dispatch(moviePageNumber(0));
                                // setNavLinkActive("bollywood")
                                dispatch(filterSelection({
                                    ...filter,
                                    catagory: "movie",
                                    movieIndustry: "bollywood"
                                }))
                            }
                            }
                        >
                            Bollywood
                        </Button>
                    </ButtonGroup>
                    <ButtonGroup className="mx-2" aria-label="Third group">
                        <Button
                            variant={filter.movieIndustry === "hollywood" ? "dark" : "outline-secondary"}
                            href="#hollywood"
                            data-toggle="tab"
                            onClick={() => {
                                // setNavLinkActive("hollywood")
                                // dispatch(moviePageNumber(0));
                                dispatch(filterSelection({
                                    ...filter,
                                    catagory: "movie",
                                    movieIndustry: "hollywood"
                                }))
                            }
                            }
                        >
                            Hollywood
                        </Button>
                    </ButtonGroup>
                    <ButtonGroup className="mx-2" aria-label="Third group">
                        <Button
                            variant={filter.movieIndustry === "south" ? "dark" : "outline-secondary"}
                            href="#south"
                            data-toggle="tab"
                            onClick={() => {
                                // dispatch(moviePageNumber(0));
                                // setNavLinkActive("south")
                                dispatch(filterSelection({
                                    ...filter,
                                    catagory: "movie",
                                    movieIndustry: "south"
                                }))
                            }
                            }
                        >
                            South
                        </Button>
                    </ButtonGroup>
                    <ButtonGroup className="mx-2" aria-label="Third group">
                        <Button
                            variant={filter.movieIndustry === "gujarati" ? "dark" : "outline-secondary"}
                            href="#gujarati"
                            data-toggle="tab"
                            onClick={() => {
                                // dispatch(moviePageNumber(0));
                                // setNavLinkActive("gujarati")
                                dispatch(filterSelection({
                                    ...filter,
                                    catagory: "movie",
                                    movieIndustry: "gujarati"
                                }))
                            }
                            }
                        >
                            Gujarati
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </div>

            {!loading &&
                <>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="all">
                            {/* {content} */}
                            <div className={`row row-cols-1 row-cols-md-${displayCol()} g-4`}>
                                {movieList.map((movie) => {
                                    var query = movie.name.replace(":", "")
                                    query = query.replace("-", "")
                                    query = query.replace(".", " ")

                                    return (
                                        <SingleMovie
                                            movie={movie}
                                            tmdbQurey={query}
                                            userData={userData}
                                            id={movie.id}
                                            userRole={userRole}
                                        />
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="mx-5" >
                        <Pagination filter={filter} page={{ pageCount, disPageNumber }} />
                    </div>
                </>
                ||
                <LoadingSpinner />
            }
        </>
    )

}

export default Movie;
